<!-- <app-table-builder [request]="getRequest" [columns]="cols" >
</app-table-builder> -->

<div style="max-width: auto; overflow: auto;">
  <app-common-list-table [tourAnchorsEnabled]="true" [request]="getRequest" [cols]="cols" [globalConditionalStyle]="globalConditionalStyle"
    [globalVisualTransform]="globalVisualTransform" [selectionMode]="tableMode()" [filtering]="filter"
    [actionButtonText]="env.canAddParcelas ? btnAnadir : ''" (actionButtonClick)="add()" (emitSearchText)="updateFooter()"
    [customExportCsv]="env.showBotonPrintParcelas" (visualize)="show('info', $event)" (edit)="edit($event)"
    (duplicate)="duplicate($event)" (remove)="show('delete', $event)" (rowClick)="getSelectedNodes($event)">

    <ng-template #headerActions>
      <button class="btn btn-primary" (click)="add()">
        <i class="fa fa-plus" aria-hidden="true"></i>
        <span> {{btnAnadir}}</span>
      </button>
      <button class="btn btn-primary" (click)="add()">
        <i class="fa fa-plus" aria-hidden="true"></i>
        <span> {{btnAnadir}}</span>
      </button>
      <button class="btn btn-primary" (click)="add()">
        <i class="fa fa-plus" aria-hidden="true"></i>
        <span> {{btnAnadir}}</span>
      </button>
      <button class="btn btn-primary" (click)="add()">
        <i class="fa fa-plus" aria-hidden="true"></i>
        <span> {{btnAnadir}}</span>
      </button>
     
    </ng-template>

    <ng-template #header>
      @if (env.appName === 'avafitogest') {
      <button class="btn btn-sm btn-primary text-white text-nowrap fw-bold" (click)="openDocumentInNewTab()">
        Obligación GIP
      </button>
      <button class="btn btn-sm btn-primary text-white text-nowrap fw-bold" (click)="activatedAssign()">
        {{ multiSelect() ? 'Desactivar Asignacion' : 'Activar Asignacion' }}
      </button>

      <button *ngIf="selectParcelas().length > 0" class="btn btn-sm btn-secondary text-white text-nowrap fw-bold" (click)="openAssignToResponsible()">
        Asignar a Responsables
      </button>

      <button *ngIf="selectParcelas().length > 0" class="btn btn-sm btn-secondary text-white text-nowrap fw-bold" (click)="openAssignToAdvisor()">
        Asignar a Asesor
      </button>
      }
    
      <div class=" justify-end d-flex  gap-4">
        <div *ngIf="env.showCampaign" id="year_campaign" style="width: 15rem !important;" class="d-flex justify-content-center">
          <label for="">Año</label>
          <p-select placeholder="{{selectedYears}}" [options]="years" [(ngModel)]="selectedYears"
            (onChange)="selectedCampaign($event.value)">
          </p-select>
        </div>
        <div class="d-flex flex-column justify-content-center text-black fw-bold">
          <small>
            Superficie total (SigPAC): <b>{{totalSupSigpac || 0}} {{env.textoSuperficie}}</b>
          </small>
          <small>
            Superficie total (cultivada): <b>{{totalSupCultivada || 0}} {{env.textoSuperficie}}</b>
          </small>
        </div>
      </div>
    </ng-template>

    <ng-template #thEnd>
      <th *ngIf="env.appName === 'agrosalvi'">
        <p class="d-flex justify-content-center" style="margin-bottom: 0">Mapa</p>
      </th>
      <th style="width: 120px;">
        <p class="mb-0 d-flex justify-content-center">Acciones</p>
      </th>
      <th>
        <p class="mb-0 d-flex justify-content-center text-wrap">Historico Cultivo</p>
      </th>
    </ng-template>

    <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
      <td *ngIf="env.appName === 'agrosalvi'">
        <div class="col col-md-1 col-offset-1">
          <button class="btn btn-warning" style="margin-left:0px !important" (click)="abreMapa(data);">
            <i class="fa fa-search" aria-hidden="true"></i>
            <span> Mapa</span>
          </button>
        </div>
      </td>
      <td>
        <div class="d-flex justify-content-center align-items-center">
        <app-action-buttons
            [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
            [showDuplicate]="env.rol !== 'responsable'"
            (duplicateRowButtonEvent)="duplicate(data.data)" [hideEdit]="!env.canEditParcelas"
            [hideDelete]="!env.canDeleteParcelas" (editRowButtonEvent)="edit(data.data)"
            (deleteRowButtonEvent)="show('delete', data.data)" (showRowButtonEvent)="show('info', data.data)">
          </app-action-buttons>

        </div>
      </td>
      <td class="text-center">
        <button style="font-size: 0.8rem; padding: 0.1rem 0.4rem;" tooltipPosition="left" pTooltip="Historico cultivos" class="btn btn-info text-center" (click)="openHistoricoCultivo(data.data)">
          <i class="fa fa-history" aria-hidden="true"></i>
        </button>
      </td>
    </ng-template>

    <ng-template #footer let-col>
      <div style="font-size: 0.75em; text-align: left" *ngIf="(['finca'].includes(col.field))">
        TOTAL:
      </div>
      <div *ngIf="(['superficie_sigpac', 'superficie_cultivada'].includes(col.field))"
        style="font-size: 0.75em; text-align: right; font-weight: bold; padding-right: 34px">
        {{col?.footer || 0}}
      </div>
    </ng-template>
  </app-common-list-table>
</div>

<app-modals
  [view]="this"
  [form]="form?.formFields"
  [serverUrl]="env.serverURL"
  [previousData]="model"
  [recordHasAssociatedData]="true"
  [getRequest]="getRequest"
  [deleteRequest]="deleteRequest">
</app-modals>


<p-dialog [header]="'Mapa ' + env.parcelaName" [(visible)]="mapaAbierto" #mapaDialog (onShow)="scrollToTop()" [modal]="true" >

  <div *ngIf="mapaAbierto" style="height:86%; margin-left:20px; margin-right:20px; width: 80vw !important">
    <app-mapa-add [origin]="origin" [finca]="finca" [localidad]="localidad" [cultivo]="cultivo" [variedad]="variedad"
      [parcelaNombre]="parcelaNombre" [coordenadas]="coordenadas" (fromMapa)="getFromMapa($event)">
    </app-mapa-add>
  </div>
  <br>

</p-dialog>

<p-dialog #dialogAsign header="Asignar Responsable" [(visible)]="assignToResponsibleOpened" [modal]="true" (onShow)="getUsersList()" 
  [style]="{'height': '80vh'}">
  <ng-template #header>
    <span class="bg-gray-500 px-2"> <b>{{selectParcelas().length}}</b> &nbsp;Parcelas seleccionadas </span>
  </ng-template>
  
  <div class="d-flex align-content-between justify-content-between flex-column overflow-hidden h-100">
    <div>
      <small>Seleccione un responsable para la(s) parcela(s) seleccionada(s):</small>
      <p-select [options]="responsables()" [filter]="true" [optionLabel]="'nombre'" [optionValue]="'id'" [(ngModel)]="selectedResponsable"></p-select>
    </div>

    <button class="btn btn-primary" [disabled]="selectedResponsable === null" (click)="assignToResponsible()">Asignar</button>

  </div>
  <ng-template #footer>
    <div class="d-flex justify-content-end">
      <button class="btn btn-secondary" (click)="openAssignToResponsible()">
        Cerrar
      </button>
    </div>
  </ng-template>
  
</p-dialog>

<p-dialog #dialogAsignAdvisor header="Asignar Asesor" [(visible)]="assignToAdvisorOpened" [modal]="true" (onShow)="getWorkersListByRoleAdvisor()" 
  [style]="{'height': '80vh'}">
  <ng-template #header>
    <span class="bg-gray-500 px-2"> <b>{{selectParcelas().length}}</b> &nbsp;Parcelas seleccionadas </span>
  </ng-template>
  
  <div class="d-flex align-content-between justify-content-between flex-column overflow-hidden h-100">
    <div>
      <small>Seleccione un asesor para la(s) parcela(s) seleccionada(s):</small>
      <p-select [options]="workersAdvisors()" [filter]="true" [optionLabel]="'nombre'" [optionValue]="'id'" [(ngModel)]="selectedAdvisor">
        <ng-template let-worker #item>
          <div class="d-flex align-items-center gap-2">
            <img *ngIf="worker.fotoUrl" [src]="worker.fotoUrl" alt="Foto" width="30" height="30" class="rounded-circle border border-1 border-secondary">
            <span>{{ worker.nombre }}</span>
          </div>
        </ng-template>
        
      </p-select>
    </div>

    <button class="btn btn-primary" [disabled]="selectedAdvisor === null" (click)="assignToAdvisor()">Asignar</button>

  </div>
  <ng-template #footer>
    <div class="d-flex justify-content-end">
      <button class="btn btn-secondary" (click)="openAssignToAdvisor()">
        Cerrar
      </button>
    </div>
  </ng-template>

</p-dialog>

<p-dialog [(visible)]="showOpenModalHistoricoCultivo" header="Histórico de Cultivos" [modal]="true" [style]="{'width': '70vw', 'height': '80vh'}">
  <div style="max-height: 60vh; overflow-y: auto;">
    <app-common-list-table [customData]="listSiembraData" [showExportCsv]="false" [cols]="colsHistoricoCultivo" [selectionMode]="'single'" [globalConditionalStyle]="globalConditionalStyle"
    [globalVisualTransform]="globalVisualTransform" >
    </app-common-list-table>
  </div>

</p-dialog>